import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import App from "../components/appStartkit";


import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout>
          <Breadcrumb category={["metoder", "metoder"]}  page={["huskur", "huskur"]}/>
     <SEO title="Huskur" description="Blek dina tänder hemma, med hjälp av husmorstips" />
    <main className="section-info">
    <section>
    <h1 class="welcome">Huskur</h1>
    <p className="text-center">
      Få vita tänder med bakpulver. Ja du läste rätt. Bikarbonat är en av ingredienserna till bakpulver och 
      det är också ett medel som allt fler idag använder till tandblekning. Eftersom bikarbonat, har en slipande 
      effekt på tändernas emalj, så kan tändernas missfärgningar och beläggningar försvinna.</p>
      <p className="text-center">
      Så ett sätt att bleka tänderna hemma själv, är att använda bakpulver eller bikarbonat.
      </p>
      <p className="text-center">
      Det finns flera smarta huskurer för att enkelt och tryggt förbättra ditt leende. Allt från afrikanska rötter till gurkmejapulver och kokosolja. Metoderna varierar i sin effektivitet och det är även personligt hur vita dina tänder kommer bli, baserat på hur missfärgade de var innan. Är du rökare, snusare eller en person som inte klarar dig utan fem koppar kaffe per dag så är metoderna i det klenaste laget.
      </p>
    </section>
  </main>
  {/* <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Startkit</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>
  <section className="section-faq">
    <FAQ />
  </section> */}
  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  <main className="section-info">
  <section>
    <h3 class="welcome">Lakritsrot</h3>
    <p className="text-center">
    I Afrika används en ört för att få naturligt rena och vita tänder. Den örten är lakritsrot. Man har hittat 5o olika ämnen som B-vitaminer, fenolämnen, kumarin och många fler. Lakrisrot blekande egenskaper är dock rätt små, men stärker framförallt din munhälsa då den är bakterie och virusdödande.
    Tugga på en liten bit torkad rot tills den blir en liten borste. Du kan använda den improviserade borsten för att rengöra dina tänder eller fortsätta att tugga på roten.</p>
    <h3 class="welcome">Oliv-/Sesam-/Kokosolja</h3>
    <p className="text-center">
    Det finns en process som heter oljedragning (en: oil pulling) och fungerar ”helt okej” för att bleka tänderna, men framförallt förbättrar din generella munhälsa. Denna tandblekande rengöringskur består av en sked olja, sesam- eller kokosolja. Gurgla oljan i munnen och mellan dina tänder på samma sätt som du använder munskölj. Detta måste göras i 15-20 minuter när du vaknar på morgonen och kan göras samtidigt som du gör din dagliga hygienrutin.</p>
    <h3 class="welcome">Helig basilika</h3>
    <p className="text-center">
    Helig basilika för gula tänder är kanske inte en helt vanlig metod för att bleka missfärgade tänder. Helig basilika är vanligt i Indien och andra länder som praktiserar naturmedicin (Ayurveda). Att få tag i såkallad ”helig basilika” så måste du gå till en asiatisk butik.

Helig basilikablad har blekande egenskaper och kan användas för att behandla gula tänder. Den är också till hjälp för att förhindra att dina tänder får problem som parodontit. Lämna några blad av helig basilika under solen i ett par timmar. När bladen blir torra, mal dem till ett fint pulver. Blanda detta pulver med din vanliga tandkräm och använd det för att borsta tänderna.</p>
    <h3 class="welcome">Apelsinskal och lagerblad</h3>
    <p className="text-center">
    En kombination av lagerblad och apelsinskal är en av de bättre huskurerna för vitare tänder och även den som smakar bäst. Ta några apelsinskal och torka dem helt i solen och mal dem till ett pulver. Gör detsamma med lagerbladen och blanda lika stora mängd av lagerbladspulver och apelsinskalpulver. Gnid denna blandning ordentligt på dina tänder. Detta kommer att göra dina tänder vitare och bekämpa eventuella tand- eller tandköttsproblem.
</p><p className="text-center">
Viktigt: se till att mala både lagerblad och apelsinskalet till pulver. Annars kan de vara rätt vassa och skada tandköttet.</p>  
<h3 class="welcome">Gurkmejapulver</h3>
    <p className="text-center">
    Du kan använda gurkmeja för att bleka dina tänder också. Mal lite gurkmeja till ett grovt pulver och tillsätt lite salt och limejuice. Använd en tandborste för att borsta dina tänder med denna växtbaserade pasta. Om du gör det i en vecka, kommer dina tänder bli lite vitare men framförallt uppleva en fräsch känsla.</p>
<h3 class="welcome">Banjan rot/pinne</h3>
    <p className="text-center">
    Banjanrot kan också användas som engångstandborste för att rengöra tänderna, precis som lakristoren. De innehåller blekande, sammandragande juicer som gör tänderna vitare och tandköttet friskare. Dock är dess blekande effekt rätt begränsad och fungerar framförallt som en tandborste/petare och ger munnen en bättre hälsa.

Om du lyckas få tag i en bit av banyanträdet så kom ihåg att tvätta rötterna ordentligt innan du använder dem.</p>    
    </section>
    </main>
    <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Startkit</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>
  </Layout>
)

export default IndexPage
